<template>
  <div>
    <b-form-select :options="options" v-model="compValue" :disabled="readonly">
    </b-form-select>
  </div>
</template>

<script>
export default {
  name: "CargoExpenseTypeDropdown",
  props: {
    value: Number,
    readonly: Boolean,
  },
  data() {
    return {
      options: [{ value: null, text: this.$t("geral.loadingData") }],
    };
  },
  created() {
    this.loadData();
  },
  computed: {
    compValue: {
      get: function () {
        if (this.options) {
          return this.value;
        }
        return null;
      },
      set: function (newValue) {
        this.$emit("update:value", parseInt(newValue));
      },
    },
    getLoadDataUrl() {
        return `/v1/cargoExpenseType/dropdownOptions`;
    }
  },
  methods: {
    loadData() {
      this.$api
        .get(this.getLoadDataUrl)
        .then((response) => {
          this.options = response.data;
          this.$forceUpdate();
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
  },
};
</script>
